// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-section {
  margin-top: 40px;
  margin-bottom: 40px;
  width: 100%;
  box-sizing: border-box;
}

.analytics-section-title {
  font-family: 'Poppins', 'Montserrat', sans-serif;
  font-size: 22px;
  font-weight: 600;
  /* color: #1e293b; */
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  padding-bottom: 10px;
}

.analytics-section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 4px;
  /* background: linear-gradient(90deg, #3b82f6, #8b5cf6); */
  border-radius: 2px;
}

.analytics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 420px), 1fr));
  gap: 24px;
  width: 100%;
}

.analytics-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
}

.analytics-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 20px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04);
}

.analytics-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 14px;
}

.analytics-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  font-size: 20px;
}

.analytics-card-header h3 {
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.analytics-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-grow: 1;
}

.analytics-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  padding: 12px 16px;
  transition: all 0.2s ease;
}

.analytics-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

/* Rank Badge styling */
.rank-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
}

.rank-1 {
  background: linear-gradient(135deg, #fbbf24, #f59e0b);
  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);
}

.rank-2 {
  background: linear-gradient(135deg, #94a3b8, #64748b);
  box-shadow: 0 2px 4px rgba(100, 116, 139, 0.3);
}

.rank-3 {
  background: linear-gradient(135deg, #cd7f32, #a15c1d);
  box-shadow: 0 2px 4px rgba(161, 92, 29, 0.3);
}

.rank-other {
  background: #cbd5e1;
  color: #475569;
}

.item-main-content {
  flex-grow: 1;
  min-width: 0;
  /* allows text truncation */
}

.item-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-subtitle {
  font-size: 12px;
  color: #64748b;
  margin: 2px 0 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.badge-blue {
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #dbeafe;
}

.badge-purple {
  background: #faf5ff;
  color: #6b21a8;
  border: 1px solid #f3e8ff;
}

/* Distributor Item Styles */
.distributor-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex-grow: 1;
}

.distributor-logo {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e2e8f0;
  background: #ffffff;
}

.distributor-status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
}

.distributor-status-dot.active {
  background-color: #22c55e;
  box-shadow: 0 0 8px #22c55e;
  animation: pulse-dot 2s infinite;
}

.distributor-status-dot.inactive {
  background-color: #94a3b8;
}

@keyframes pulse-dot {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 6px rgba(34, 197, 94, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
  }
}

.badge-green-active {
  background: #ecfdf5;
  color: #065f46;
  border: 1px solid #a7f3d0;
}

.badge-gray-inactive {
  background: #f8fafc;
  color: #475569;
  border: 1px solid #e2e8f0;
}

/* Video action button */
.video-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f1f5f9;
  color: #475569;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}

.video-action-btn:hover {
  background: #3b82f6;
  color: #ffffff;
  transform: scale(1.1);
}

.no-data-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  color: #94a3b8;
  font-size: 14px;
  font-style: italic;
  text-align: center;
  width: 100%;
}

.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: #fff5f5;
  border: 1px solid #fed7d7;
  border-radius: 16px;
  color: #c53030;
  text-align: center;
  width: 100%;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  width: 100%;
  gap: 16px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  color: #64748b;
  font-size: 15px;
  font-weight: 500;
}

/* Custom scrollbar for analytics lists */
.analytics-list::-webkit-scrollbar {
  width: 6px;
}

.analytics-list::-webkit-scrollbar-track {
  background: transparent;
}

.analytics-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.analytics-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Responsive breakdowns */
@media (max-width: 1300px) {
  .analytics-grid {
    gap: 20px;
  }

  .analytics-card {
    padding: 20px;
  }
}

@media (max-width: 900px) {
  .analytics-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .analytics-section-title {
    font-size: 18px;
    margin-bottom: 18px;
  }

  .analytics-card {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .analytics-section {
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .analytics-card {
    padding: 14px;
  }

  .analytics-item {
    padding: 10px 12px;
    gap: 8px;
  }

  .badge-pill {
    padding: 4px 8px;
    font-size: 11px;
  }

  .item-title {
    font-size: 13px;
  }

  .item-subtitle {
    font-size: 11px;
  }
}

@media (max-width: 440px) {

  /* For very narrow phones, wrap list items to stack content and badges */
  .analytics-item {
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px;
  }

  .distributor-main-info {
    flex-wrap: wrap;
    gap: 8px;
  }

  .distributor-left {
    width: 100%;
    margin-bottom: 4px;
  }

  .distributor-right-actions {
    margin-left: auto;
  }

  .item-main-content {
    width: calc(100% - 48px);
  }

  .badge-pill {
    margin-left: auto;
  }

  .video-action-btn {
    margin-left: 6px;
  }
}

/* Distributor activity item modifications */
.analytics-item.distributor-activity-item {
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  padding: 12px 16px;
}

.distributor-main-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}

.distributor-right-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toggle-offline-users-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.toggle-offline-users-btn:hover {
  background: #cbd5e1;
  color: #0f172a;
}

.distributor-offline-users-list {
  border-top: 1px dashed #e2e8f0;
  padding-top: 10px;
  margin-top: 4px;
  animation: fadeIn 0.2s ease-out;
}

.offline-users-header {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.offline-icon {
  color: #94a3b8;
}

.offline-users-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 150px;
  overflow-y: auto;
  padding-right: 4px;
}

/* Custom scrollbar for offline user list if it overflows */
.offline-users-chips::-webkit-scrollbar {
  width: 4px;
}

.offline-users-chips::-webkit-scrollbar-track {
  background: transparent;
}

.offline-users-chips::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.offline-user-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 4px 8px;
  transition: all 0.2s ease;
}

.offline-user-chip:hover {
  background: #e2e8f0;
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

.offline-user-initials {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #cbd5e1;
  color: #475569;
  font-size: 9px;
  font-weight: 700;
}

.offline-user-name {
  font-size: 12px;
  font-weight: 500;
  color: #334155;
  white-space: nowrap;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/AnalyticsReport.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,0DAA0D;EAC1D,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kFAAkF;EAClF,iDAAiD;EACjD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,oFAAoF;AACtF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;;EAEA;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,wEAAwE;EACxE;IACE,eAAe;IACf,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,4CAA4C;AAC5C;EACE,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".analytics-section {\n  margin-top: 40px;\n  margin-bottom: 40px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.analytics-section-title {\n  font-family: 'Poppins', 'Montserrat', sans-serif;\n  font-size: 22px;\n  font-weight: 600;\n  /* color: #1e293b; */\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n  padding-bottom: 10px;\n}\n\n.analytics-section-title::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 60px;\n  height: 4px;\n  /* background: linear-gradient(90deg, #3b82f6, #8b5cf6); */\n  border-radius: 2px;\n}\n\n.analytics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 420px), 1fr));\n  gap: 24px;\n  width: 100%;\n}\n\n.analytics-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  flex-direction: column;\n}\n\n.analytics-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 12px 20px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04);\n}\n\n.analytics-card-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #f1f5f9;\n  padding-bottom: 14px;\n}\n\n.analytics-card-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  font-size: 20px;\n}\n\n.analytics-card-header h3 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  color: #0f172a;\n  margin: 0;\n}\n\n.analytics-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex-grow: 1;\n}\n\n.analytics-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  background: #f8fafc;\n  border: 1px solid #f1f5f9;\n  border-radius: 12px;\n  padding: 12px 16px;\n  transition: all 0.2s ease;\n}\n\n.analytics-item:hover {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n/* Rank Badge styling */\n.rank-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  font-size: 13px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.rank-1 {\n  background: linear-gradient(135deg, #fbbf24, #f59e0b);\n  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);\n}\n\n.rank-2 {\n  background: linear-gradient(135deg, #94a3b8, #64748b);\n  box-shadow: 0 2px 4px rgba(100, 116, 139, 0.3);\n}\n\n.rank-3 {\n  background: linear-gradient(135deg, #cd7f32, #a15c1d);\n  box-shadow: 0 2px 4px rgba(161, 92, 29, 0.3);\n}\n\n.rank-other {\n  background: #cbd5e1;\n  color: #475569;\n}\n\n.item-main-content {\n  flex-grow: 1;\n  min-width: 0;\n  /* allows text truncation */\n}\n\n.item-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.item-subtitle {\n  font-size: 12px;\n  color: #64748b;\n  margin: 2px 0 0 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.badge-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.badge-blue {\n  background: #eff6ff;\n  color: #1d4ed8;\n  border: 1px solid #dbeafe;\n}\n\n.badge-purple {\n  background: #faf5ff;\n  color: #6b21a8;\n  border: 1px solid #f3e8ff;\n}\n\n/* Distributor Item Styles */\n.distributor-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n  flex-grow: 1;\n}\n\n.distributor-logo {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\n.distributor-status-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 6px;\n}\n\n.distributor-status-dot.active {\n  background-color: #22c55e;\n  box-shadow: 0 0 8px #22c55e;\n  animation: pulse-dot 2s infinite;\n}\n\n.distributor-status-dot.inactive {\n  background-color: #94a3b8;\n}\n\n@keyframes pulse-dot {\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);\n  }\n\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 6px rgba(34, 197, 94, 0);\n  }\n\n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);\n  }\n}\n\n.badge-green-active {\n  background: #ecfdf5;\n  color: #065f46;\n  border: 1px solid #a7f3d0;\n}\n\n.badge-gray-inactive {\n  background: #f8fafc;\n  color: #475569;\n  border: 1px solid #e2e8f0;\n}\n\n/* Video action button */\n.video-action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #f1f5f9;\n  color: #475569;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n}\n\n.video-action-btn:hover {\n  background: #3b82f6;\n  color: #ffffff;\n  transform: scale(1.1);\n}\n\n.no-data-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 120px;\n  color: #94a3b8;\n  font-size: 14px;\n  font-style: italic;\n  text-align: center;\n  width: 100%;\n}\n\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  background: #fff5f5;\n  border: 1px solid #fed7d7;\n  border-radius: 16px;\n  color: #c53030;\n  text-align: center;\n  width: 100%;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 40px;\n  width: 100%;\n  gap: 16px;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-text {\n  color: #64748b;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n/* Custom scrollbar for analytics lists */\n.analytics-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.analytics-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.analytics-list::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.analytics-list::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Responsive breakdowns */\n@media (max-width: 1300px) {\n  .analytics-grid {\n    gap: 20px;\n  }\n\n  .analytics-card {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 900px) {\n  .analytics-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .analytics-section-title {\n    font-size: 18px;\n    margin-bottom: 18px;\n  }\n\n  .analytics-card {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .analytics-section {\n    margin-top: 24px;\n    margin-bottom: 24px;\n  }\n\n  .analytics-card {\n    padding: 14px;\n  }\n\n  .analytics-item {\n    padding: 10px 12px;\n    gap: 8px;\n  }\n\n  .badge-pill {\n    padding: 4px 8px;\n    font-size: 11px;\n  }\n\n  .item-title {\n    font-size: 13px;\n  }\n\n  .item-subtitle {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 440px) {\n\n  /* For very narrow phones, wrap list items to stack content and badges */\n  .analytics-item {\n    flex-wrap: wrap;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .distributor-main-info {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .distributor-left {\n    width: 100%;\n    margin-bottom: 4px;\n  }\n\n  .distributor-right-actions {\n    margin-left: auto;\n  }\n\n  .item-main-content {\n    width: calc(100% - 48px);\n  }\n\n  .badge-pill {\n    margin-left: auto;\n  }\n\n  .video-action-btn {\n    margin-left: 6px;\n  }\n}\n\n/* Distributor activity item modifications */\n.analytics-item.distributor-activity-item {\n  flex-direction: column;\n  align-items: stretch;\n  gap: 10px;\n  padding: 12px 16px;\n}\n\n.distributor-main-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 12px;\n}\n\n.distributor-right-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.toggle-offline-users-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.toggle-offline-users-btn:hover {\n  background: #cbd5e1;\n  color: #0f172a;\n}\n\n.distributor-offline-users-list {\n  border-top: 1px dashed #e2e8f0;\n  padding-top: 10px;\n  margin-top: 4px;\n  animation: fadeIn 0.2s ease-out;\n}\n\n.offline-users-header {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.offline-icon {\n  color: #94a3b8;\n}\n\n.offline-users-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  max-height: 150px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n/* Custom scrollbar for offline user list if it overflows */\n.offline-users-chips::-webkit-scrollbar {\n  width: 4px;\n}\n\n.offline-users-chips::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.offline-users-chips::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 2px;\n}\n\n.offline-user-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 4px 8px;\n  transition: all 0.2s ease;\n}\n\n.offline-user-chip:hover {\n  background: #e2e8f0;\n  border-color: #cbd5e1;\n  transform: translateY(-1px);\n}\n\n.offline-user-initials {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #cbd5e1;\n  color: #475569;\n  font-size: 9px;\n  font-weight: 700;\n}\n\n.offline-user-name {\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n  white-space: nowrap;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
